import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, Renderer2, HostListener, } from '@angular/core';
import { BaseQueovalItem, GQueovalDik, QueovalItem, QResult } from '../../models';
import { TagModel } from '../../models/tag';
import { CoreService, HttpService } from '../../services';
import { debounceTime, distinctUntilChanged, mergeMap, switchMap } from 'rxjs/operators';
import { FilterBadgeModel, FilterPropertyType, Operator } from '../../filter';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'q-quicksearch',
  templateUrl: './quicksearch.component.html',
  styleUrls: ['./quicksearch.component.css']
})

export class QuickSearchComponent {

  constructor(
    private indParam: CoreService,
    private http: HttpService,
    private renderer: Renderer2,
  ) { }

  //Variable pour la recherche
  @ViewChild('proposalPopover') proposalPopover: ElementRef;
  proposalPopoverOpen: boolean;
  displayShowMore: boolean;
  showMore: boolean;

  searchTerm: string = '';
  searchResults: Array<QueovalItem> = Array<QueovalItem>();

  noProposal: boolean;

  selectedProposal: Array<QueovalItem> = Array<QueovalItem>();
  proposalSlice: number = 10;

  badgeExpendNumber: number;
  badgeSliceEnd: number;
  badgeExpended: boolean;

  //variable mode de selection
  @ViewChild('modeSelector') modeSelector: ElementRef;
  modeSelectorOpen: boolean
  searchModes: Array<QuickSearch> = new Array<QuickSearch>();
  selectedMode: QuickSearch = new QuickSearch();
  forcedSelectedModel: string;

  //variable tag 
  tagRelation: string;
  tags: Array<QueovalItem> = new Array<QueovalItem>();

  @ViewChild('badgeWrapper') badgeWrapper: ElementRef;
  @ViewChild('searchWrapper') searchWrapper: ElementRef;

  firstLoad = true;

  // Entrée pour le badge de filtre
  @Input('FilterBadge') set filterBadge(value: Array<FilterBadgeModel>) {
    if (this.firstLoad) {
      this.firstLoad = false;
      if (!value) return;
      // Filtrer les badges pour les badges de type de propriété QuickSearch
      const qsFilter = value.filter((badge: FilterBadgeModel) => badge.PropType == FilterPropertyType.QuickSearch);
      if (qsFilter.length > 0) {
        // Récupérer la valeur du badge pour le mode de recherche sélectionné
        this.forcedSelectedModel = qsFilter[0].Value?.split('|')[0]!;

        // Convertir les badges en objets QueovalItem pour les propositions sélectionnées
        this.selectedProposal = qsFilter.map((badge: FilterBadgeModel) => {
          let queovalItem = new QueovalItem();
          queovalItem = { Value: badge.PropValue, Text: badge.Text, Selected: false, Tooltip: badge.Value!.split('|')[1] };
          return queovalItem;
        })
        setTimeout(() => { this.computBadgeSize(); }, 0);
      }
    }
  };

  // Entrée pour les données de recherche
  @Input('data') set data(value: Array<QuickSearch>) {
    if (value) {

      if (value.some(e => !e.key)) {
        throw new Error(`l'une des key d'une des options du quicksearch est vide`);
      }


      this.searchModes = value // Concaténer les modes de recherche avec les tags
      const tagSearch = value.find(e => e.mode == 'TAG');
      if (tagSearch) {
        if (!tagSearch.relationName) {
          throw new Error('tag relationName vide dans la delcaration des options du quicksearch');
        };

        this.getTag(tagSearch.relationName);
      }


      if (this.forcedSelectedModel) {
        this.selectMode(this.searchModes.find((mode: QuickSearch) => mode.mode == this.forcedSelectedModel)!, false);
      } else {
        this.selectMode(value[0], false);
      }
    }
  }

  /* @Input('relation') set relation(value: string) {
     if (value) {
       this.haveTag = true;
       this.tagRelation = value;
       this.getTag();
     }
   }*/

  @Output() result: EventEmitter<Array<FilterBadgeModel>> = new EventEmitter<Array<FilterBadgeModel>>();

  @HostListener('window:click', ['$event']) clickEvent(event: any) {
    this.managePopOverClosure();
  }

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.computBadgeSize();
  }

  //#region proposal popover

  // Méthode pour gérer l'événement de recherche
  onSearch(): void {
    if (this.searchTerm.length >= 2) {
      if (this.selectedMode.mode == 'TAG') {
        // Recherche basée sur les tags
        this.searchResults = this.tags.filter(x => x.Text.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()));
        this.noProposal = this.searchResults.length == 0;
        this.displayShowMore = !this.showMore && this.searchResults.length > 10;
        this.openProposalPopover();
        return;
      }
      // Recherche basée sur texte saisi
      this.selectedMode.searchTerm = this.searchTerm;
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/mainsearch/QuickSearch`, this.selectedMode).pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((results: QResult<Array<BaseQueovalItem>>) => {

          // Traitement des résultats de recherche pour les afficher dans la popover de propositions
          this.searchResults = results.Value.map((x: any) => {
            const qi = new QueovalItem();
            qi.Value = x.Value;
            qi.Text = x.Text;
            if (this.selectedProposal.length > 0) {
              qi.Selected = this.selectedProposal.some(y => [y.Value].includes(qi.Value));
            }
            return qi;
          });
          this.proposalSlice = 10;
          this.noProposal = this.searchResults.length == 0;
          this.displayShowMore = !this.showMore && this.searchResults.length > 10;
          this.openProposalPopover();
          return [];
        })
      ).subscribe();
    } else {
      this.searchResults = [];
      this.closeProposalPopover();
    }
  }

  // Méthode pour ouvrir la popover de propositions
  openProposalPopover(event?: MouseEvent) {
    if (event) { event.stopPropagation(); }
    if (this.proposalPopoverOpen || this.searchTerm.length < 2) {
      this.proposalHeight();
      return;
    }

    this.managePopOverClosure();
    this.proposalPopoverOpen = true;

    // Rendre visible la popover de propositions
    this.renderer.setStyle(this.proposalPopover.nativeElement, 'display', 'block');
    // Calculer la hauteur de la popover de propositions
    this.proposalHeight();
  }
  // Méthode pour calculer la hauteur de la popover de propositions
  proposalHeight() {
    setTimeout(() => {
      let displayNumber = this.searchResults.length > 10 ? 10 : this.searchResults.length;
      if (this.proposalPopover.nativeElement.querySelector('.proposal-popover__main')) {
        this.renderer.setStyle(this.proposalPopover.nativeElement.querySelector('.proposal-popover__main'), 'height', `${30 * displayNumber}px`);
      }
    }, 0)

  }

  openSearch(event: MouseEvent) {
    event.stopPropagation();
    if (!this.proposalPopoverOpen && this.searchTerm.length >= 2) {
      this.openProposalPopover();// Ouvre la popover de recherche
    }
  }

  closeProposalPopover() {
    this.proposalPopoverOpen = false; // Ferme la popover de recherche
    this.displayShowMore = true; // Affiche le bouton "Afficher plus"
    this.showMore = false; // Cache le contenu "Afficher plus"
    this.proposalSlice = 10; // Réinitialise la pagination des résultats de recherche
    if (this.proposalPopover) {
      this.renderer.setStyle(this.proposalPopover.nativeElement, 'display', 'none'); // Rendre visible la popover de recherche
    }

  }

  getArrowKeys(event: any) {
    if (!this.proposalPopoverOpen) return; // Si la popover de recherche est deja fermée, retourne
    if (this.searchResults.length == 0) return; // Si la liste des résultats de recherche est vide, retourne
    if (event.code == 'Enter') {
      this.containProposal(); // Si la touche "Entrée" est pressée, effectue une recherche "Contient"
    }
  }

  selectProposal(proposal: QueovalItem) {
    if (proposal.Selected) return; // Si la proposition est déjà sélectionnée, retourne
    this.selectedProposal.push(proposal); // Ajoute la proposition sélectionnée à la liste des propositions sélectionnées
    this.computBadgeSize(); // Calcule la taille des badges et ajuste l'affichage
    this.emitResult();// Émet le résultat de la sélection
  }

  containProposal() {
    if (this.searchResults.length == 0) return; // Si la liste des résultats de recherche est vide, retourne
    this.selectedProposal = this.selectedProposal.filter(f => f.Tooltip != "CONTAIN"); // Filtre les propositions déjà sélectionnées pour ne conserver que celles qui ne sont pas "CONTAIN"
    this.selectedProposal.push({ Text: `Contient: '${this.searchTerm}'`, Value: this.searchResults.map(x => x.Value).join(','), Selected: true, Tooltip: "CONTAIN" }); // Ajoute une nouvelle proposition "CONTAIN"
    this.emitResult(); // Émet le résultat de la sélection
    this.computBadgeSize(); // Calcule la taille des badges et ajuste l'affichage
  }

  public computBadgeSize() {
    this.closeProposalPopover(); // Ferme la popover de recherche

    this.searchTerm = ''; // Réinitialise le text de recherche saisi
    this.badgeSliceEnd = this.selectedProposal.length; // Définit le nombre de propositions à afficher dans les badges

    this.badgeExpendNumber = 0; // Réinitialise le nombre de propositions masquées
    let elementCount: number = 0; // Compteur d'éléments
    let elementWidth: number = 0; // Largeur totale des éléments

    //le -200 est arbitraire mais c'est pour laisser sifficamenet de place pour l'input de recherche
    let availableSize = 0;
    if (this.badgeWrapper)
     availableSize = this.badgeWrapper.nativeElement.clientWidth + this.searchWrapper.nativeElement.clientWidth - 200;

    this.selectedProposal.every((badge: BaseQueovalItem) => {

      //Creation de badge factice pour calculer leurs largeurs
      let filterBadge = document.createElement('div');
      filterBadge.classList.add('badge-proposal--computed');
      filterBadge.innerHTML = `<div>${badge.Text}</div>`;
      filterBadge.style.visibility = 'hidden';
      document.body.append(filterBadge)

      // les +3 dans les calcules sont les margins rigth qui ne sont pas prise en compte dans le getclientrects et c'est overkill de faire un getcomputedstyle pour recup une valeur qui ne va pas changer 
      let filterBadgeChild: any = filterBadge.childNodes[0];
      let badgeWidth: number = filterBadgeChild.getClientRects()[0].width + 3;

      filterBadge.remove();

      //Recuperation du nombre de badge max que l'on peut afficher sur une ligne 
      if (elementWidth + badgeWidth > availableSize) {
        if (!this.badgeExpended) {
          this.badgeSliceEnd = elementCount;
        }
        return false;
      }

      elementWidth += badgeWidth;

      elementCount++;
      return true;
    });

    this.badgeExpendNumber = this.selectedProposal.length - elementCount;
    if (this.badgeExpendNumber == 0) {
      this.badgeExpended = false;
    }
  }

  deleteProposal(proposal: QueovalItem) {
    let propsalIndex = this.selectedProposal.indexOf(proposal); // Recherche l'index de la proposition sélectionnée dans le tableau des propositions sélectionnées
    if (propsalIndex > -1) { // Vérifie si l'index de la proposition est valide
      this.selectedProposal!.splice(propsalIndex, 1); // Supprime la proposition des propositions sélectionnées
      this.computBadgeSize(); // Calcule la taille des badges et ajuste l'affichage
      this.emitResult(); // Émet le résultat de la sélection
    }
  }

  showMoreProposal(event: any) {
    event.stopPropagation();
    this.displayShowMore = false; // Masque le button "Afficher plus"
    this.showMore = true; // Affiche plus de propositions
    this.proposalSlice = this.searchResults.length;  // Définit la limite du nombre de propositions affichées à la taille du tableau des résultats de recherche
  }
  //#endregion

  selectMode(mode: QuickSearch, sendData = true) {
    this.searchModes.forEach(m => {
      m.selected = mode.mode == m.mode ? true : false; // Parcourt le tableau des modes de recherche et met à jour l'état sélectionné en fonction du mode passé en argument
    });
    this.selectedMode = mode; // Met à jour le mode de recherche sélectionné

    // Si l'argument sendData est vrai et qu'il y a des propositions sélectionnées
    // On vient reinitialiser les proposition sélectionnées
    if (sendData && this.selectedProposal.length > 0) {
      this.searchResults = []; // Réinitialise le tableau des résultats de recherche
      this.selectedProposal = new Array<QueovalItem>(); // Réinitialise le tableau des propositions sélectionnées
      this.emitResult(); // Émet le résultat de la sélection
    }
    this.computBadgeSize(); // Calcule la taille des badges et ajuste l'affichage
    this.searchTerm = ''; // Réinitialise le text de recherche saisi

    this.managePopOverClosure(); // Gère la fermeture des popovers
  }

  openModeSelector(event: MouseEvent) {
    event.stopPropagation();
    this.managePopOverClosure();// Gère la fermeture des popovers
    this.modeSelectorOpen = true; // Ouvre la popover de sélection du mode de recherche

    //rendre visible la selection des modes de recherche
    this.renderer.setStyle(this.modeSelector.nativeElement, 'display', 'block');
  }

  managePopOverClosure() {
    //fermeture de mode selector
    if (this.modeSelectorOpen) {
      this.renderer.setStyle(this.modeSelector.nativeElement, 'display', 'none');
      this.modeSelectorOpen = false;
    }
    //fermeture du quick search
    if (this.proposalPopoverOpen) {
      this.closeProposalPopover()
    }
  }

  emitResult() {
    let badges: Array<FilterBadgeModel> = new Array<FilterBadgeModel>();
    this.selectedProposal.forEach((proposal: QueovalItem) => {
      badges.push({
        PropKey: this.selectedMode.key!,
        PropOperator: Operator.In,
        PropType: FilterPropertyType.QuickSearch,
        Value: `${this.selectedMode.mode}|${proposal.Tooltip}`,
        Text: proposal.Text,
        PropValue: proposal.Value,
        Hidden: true,
        PropInWhere: true,

      })
    });
    this.result.emit(badges);
  }

  getTag(tagRelation: string) {
    let tagModel = new TagModel();
    tagModel.relation = tagRelation;
    tagModel.Mode = 'GET_ALL_TAG_AND_PERE';

    this.http.postHttp<TagModel>(`${this.indParam.AppParams.apiUrl}api/tag/`, tagModel).subscribe((data: TagModel) => {
      for (let i: number = 0; i < data.tags.length; i++) {
        this.tags.push({ Text: data.tags[i], Value: data.listIdPere[i], Selected: false, Tooltip: '' });
      }
    });
  }
}

export class QuickSearch {
  //Text d'affichage
  public titre: string;
  //clé unique pour que le système différencie les options
  public mode: string;
  public data?: Array<GQueovalDik<string, Array<string>>>

  //Permets de définir la PropKey de badgeFilter qui va être envoyé en réponse
  public key?: string;
  //Nom de la table ou la requête va cherche les infos
  public tableName?: string;
  //Colonne dans laquelle la requête va cherche les infos
  public propSearchName?: string;
  //Permet de définir les infos qui vont être remonté pour etre afficher dans la liste des propositions
  public propDisplayName?: string;
  //Relation pour effectuer la requête
  public relationName?: string;
  //Relation d'origine pour effectuer la requête
  public relationNameOrigine?: string;
  //Si l'info vient du pere ou fils de la relation
  public isBoPere?: Boolean;
  public searchTerm?: string;
  public selected?: boolean;

  public constructor() {
    this.isBoPere = false;
  }
}
